import Alpine from 'alpinejs'
import 'swiped-events';

import confetti from "canvas-confetti";
Livewire.on('confetti', () => {
    confetti({
        particleCount: 300,
        spread: 150,
        origin: {y: 0.6}
    });
})

require('./bootstrap');

window.Alpine = Alpine
Alpine.start()
